import { createSvgIcon } from '@automata/mui-theme';
export const HamiltonStarIcon = createSvgIcon(
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.4827 24.8562L15.5169 23.1443L63.0016 51.833L82.4853 40.1428L83.5143 41.8577L62.998 54.1675L14.4827 24.8562Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M61.9998 81.0002V53.0002H63.9998V81.0002H61.9998Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M53.8363 78.0002L15.7279 54.958L18.0074 53.5332L56.9998 77.6714V78.0002H53.8363ZM11.3918 55.8419L52.7612 80.856C52.9173 80.9504 53.0962 81.0002 53.2787 81.0002H58.9998C59.5521 81.0002 59.9998 80.5525 59.9998 80.0002V76.5573C59.9998 76.211 59.8206 75.8893 59.5262 75.707L18.5287 50.3276C18.2049 50.1272 17.7953 50.1281 17.4724 50.3299L11.3792 54.1381C10.747 54.5332 10.7539 55.4562 11.3918 55.8419Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M62.4868 82.6862C62.4876 82.6867 62.4883 82.6872 62.4891 82.6876C62.804 82.8793 63.199 82.8822 63.5167 82.6949C63.517 82.6947 63.5174 82.6945 63.5177 82.6943L84.5086 70.2906C84.5089 70.2904 84.5093 70.2902 84.5097 70.2899C84.8135 70.1099 84.9998 69.7829 84.9998 69.4297V40.5705C84.9998 40.2175 84.8137 39.8907 84.5102 39.7106C84.5099 39.7104 84.5095 39.7101 84.5091 39.7099L36.5087 11.3015C36.1949 11.1158 35.8047 11.1156 35.4907 11.3012L14.4911 23.71C14.4908 23.7102 14.4905 23.7104 14.4902 23.7106C14.1863 23.8906 13.9998 24.2176 13.9998 24.571V52.44C13.9998 52.4598 14.0004 52.4795 14.0016 52.4991L16.9998 50.6252V25.7122L35.9986 14.4857L81.9998 41.7109V68.2884L63.0273 79.4995L59.9997 77.6459L59.9998 80.0002C59.9998 80.0206 59.9991 80.0408 59.9979 80.0608C59.9775 80.4024 59.7857 80.6977 59.5073 80.8621L62.4868 82.6862Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M62.0141 40.1593L35.8481 24.0237L36.9856 23.3412L63.1515 39.4768L62.0141 40.1593ZM33.3991 24.8631L61.4821 42.181C61.8001 42.3771 62.201 42.3795 62.5214 42.1873L65.5902 40.346C66.2329 39.9604 66.2386 39.0308 65.6006 38.6374L37.5176 21.3195C37.1995 21.1234 36.7986 21.121 36.4782 21.3132L33.4095 23.1545C32.7667 23.5401 32.7611 24.4697 33.3991 24.8631Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M44.3434 48.7726L14.4853 30.8577L15.5143 29.1428L45.6563 47.2279L51.1563 53.7279L63.5143 61.1427L62.4853 62.8577L49.8434 55.2726L44.3434 48.7726Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M83.5143 60.8577L63.5143 72.8577L62.4853 71.1427L82.4853 59.1427L83.5143 60.8577Z"
    />
  </svg>,
  'HamiltonStarIcon'
);
